<p *ngIf="isShowTimer" class="text-xs text-[#737373]">You can request a new code in: {{ formatTime(timeRemaining) }} </p>
